<!--
 - Order messages component
 -
 - @version
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.37.0 OAUI-527 Slowdowns in order modals
 - 4.36.0 OAUI-529 Add order messages is not available unless an order has been edited
 - 4.36.0 OAUI-518 Add order reports and exports
 - 4.36.0 OAUI-515 Add / Edit / Remove Order Messages
 - 4.35.0 OAUI-499 View Order Messages
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022 Build Centrix
 -->
<div class="order-messages">
  <div
    class="message-history"
    *ngIf="messages?.length > 0"
    [ngClass]="{ 'full-height': !wdEnvironmentService.permissions.canAddOrderMessages }"
  >
    <ul>
      <li *ngFor="let entry of messages">
        <!--Transaction Messages-->
        <div *ngIf="entry.type === 'transaction'">
          <div class="message-data align-right">
            <span
              class="message-data-time"
              title="{{entry.dateCreated|date:'medium'}}"
            >
              {{entry.dateTimeDisplay}}
            </span>
            <span
              class="message-data-name"
              title="{{entry.user ? entry.user.firstName + ' ' + entry.user.lastName : 'BCX'}}"
            >
              {{entry.user ? entry.user.firstName : 'BCX'}}
            </span>
            <span>
              <bc-atoms-icon type="webduct"></bc-atoms-icon>
            </span>
          </div>
          <div class="message system-message float-right">
            {{entry.message}}
          </div>
        </div>

        <!--User Messages-->
        <div *ngIf="entry.type === 'user'">
          <div class="message-data">
            <span>
              <bc-atoms-icon type="user"></bc-atoms-icon>
            </span>
            <span *ngIf="entry.visibility === 1">
              <bc-atoms-icon
                type="email"
                title="{{'order.messages.notified.description'|translate}}"
              ></bc-atoms-icon>
            </span>
            <span
              class="message-data-name"
              title="{{entry.user ? entry.user.firstName + ' ' + entry.user.lastName : 'BCX'}}"
            >
              {{entry.user ? entry.user.firstName : 'BCX'}}
            </span>
            <span
              class="message-data-time"
              title="{{entry.dateCreated|date:'medium'}}"
            >
              {{entry.dateTimeDisplay}}
            </span>
          </div>
          <div class="message user-message">
            <div *ngIf="!entry.isEditing">
              <div
                *ngIf="!wdEnvironmentService.permissions.canEditOrderMessages &&
                              !wdEnvironmentService.permissions.canDeleteOrderMessages"
              >
                {{entry.message}}
              </div>
              <div>
                <div
                  class="dropdown"
                  *ngIf="wdEnvironmentService.permissions.canEditOrderMessages ||
                          wdEnvironmentService.permissions.canDeleteOrderMessages"
                >
                  <button
                    class="btn btn-link dropdown-toggle message-button"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{entry.message}}
                  </button>
                  <div
                    class="dropdown-menu message-options"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <bc-atoms-button
                      *ngIf="wdEnvironmentService.permissions.canEditOrderMessages"
                      class="dropdown-item"
                      [label]="('actions.edit'|translate)"
                      [title]="('actions.edit'|translate)"
                      [loading]="entry.isDeleting"
                      [disabled]="entry.isDeleting"
                      type="linkDanger"
                      display="block"
                      size="small"
                      (onButtonClicked)="startEditOrderMessage(entry)"
                    >
                    </bc-atoms-button>
                    <bc-atoms-button
                      *ngIf="wdEnvironmentService.permissions.canDeleteOrderMessages"
                      class="dropdown-item"
                      [label]="('actions.delete'|translate)"
                      [title]="('actions.delete'|translate)"
                      [loading]="entry.isDeleting"
                      [disabled]="entry.isDeleting"
                      type="linkDanger"
                      display="block"
                      size="small"
                      [confirmTitle]="('actions.removeType'|translate:{ type:('order.messages.singular.title'|translate) })"
                      (onButtonClicked)="deleteOrderMessage(entry)"
                    >
                      <div confirmation-body>
                        <div>{{'prompts.confirmDeleteMessage'|translate}}</div>
                        <div class="ml-4 mr-4 text-center text-muted">
                          <br />"{{entry.message}}"<br />
                        </div>
                      </div>
                    </bc-atoms-button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="entry.isEditing">
              <div class="mb-2">
                <bc-atoms-textarea
                  id="entryMessage_{{entry.index}}"
                  name="entryMessage_{{entry.index}}"
                  placeholder="{{'order.instructions.title'|translate}}"
                  title="{{'order.instructions.description'|translate}}"
                  size="small"
                  [autofocus]="true"
                  [disabled]="false"
                  [rows]="1"
                  [(model)]="entry.message"
                  [(ngModel)]="entry.message"
                ></bc-atoms-textarea>
              </div>
              <div class="row">
                <div class="col-6">
                  <bc-atoms-button
                    label="{{'actions.cancel'|translate }}"
                    title="{{'actions.cancel'|translate }}"
                    icon="cancel"
                    type="default"
                    size="small"
                    display="block"
                    [loading]="false"
                    [disabled]="false"
                    (onButtonClicked)="cancelEditOrderMessage(entry)"
                  >
                    <!---->
                  </bc-atoms-button>
                </div>
                <div class="col-6">
                  <bc-atoms-button
                    label="{{'actions.save'|translate }}"
                    title="{{'actions.save'|translate }}"
                    icon="save"
                    type="info"
                    size="small"
                    display="block"
                    [loading]="false"
                    [disabled]="false"
                    (onButtonClicked)="editOrderMessage(entry)"
                  >
                  </bc-atoms-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div
    class="none-found"
    *ngIf="messages?.length === 0"
    [ngClass]="{ 'full-height': !wdEnvironmentService.permissions.canAddOrderMessages }"
  >
    <div class="none-found-message">
      {{'order.messages.notFound'|translate}}
    </div>
  </div>
  <div
    class="message-input"
    *ngIf="wdEnvironmentService.permissions.canAddOrderMessages"
  >
    <div class="msg-input">
      <bc-atoms-input
        id="orderMessage"
        name="orderMessage"
        title="{{'order.messages.add.description'|translate}}"
        placeholder="{{'order.messages.add.title'|translate}}"
        size="small"
        [disabled]="isMessagesUpdating"
        [(model)]="message"
        (keyup.enter)="addOrderMessage(message)"
      >
      </bc-atoms-input>
    </div>
    <div class="add-button">
      <bc-atoms-button
        label="{{'actions.add'|translate }}"
        title="{{'actions.add'|translate }}"
        icon="add"
        type="default"
        size="small"
        display="block"
        [loading]="isMessagesUpdating"
        [disabled]="!message || isMessagesUpdating"
        (onButtonClicked)="addOrderMessage(message)"
      >
      </bc-atoms-button>
    </div>
  </div>
</div>
